/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-summary-label': 'Résumer',
  'copy-content-link-label': 'Copier le lien',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Commencez à taper pour rechercher une étiquette',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Tous',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrer la recherche par produit',
  'dynamic-cards-search-page.atlas.for': 'pour',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Calendrier',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Rejoindre la réunion',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Lien vers la réunion',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Rejoindre la réunion',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Événements passés',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Événement récurrent',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Récurrent',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Événements à venir',
  'dynamic-cards-search-page.compass.owner-name': 'Propriétaire : {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Tier {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Rechercher du contenu',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Sélectionné',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Suggéré',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Sélectionné',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Suggéré',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Rechercher des personnes',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Sélectionné',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Rechercher des étiquettes',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Rechercher des espaces',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Connectez votre compte pour voir les résultats manquants',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Votre administrateur a ajouté {product} !',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} est maintenant disponible !',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end':
    'La date de début doit être antérieure à la date de fin',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'La date de début ne peut être dans le futur',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'La date de fin ne peut être dans le futur',
  'dynamic-cards-search-page.date.filter.last.month': '30 derniers jours',
  'dynamic-cards-search-page.date.filter.last.week': '7 derniers jours',
  'dynamic-cards-search-page.date.filter.last.year': 'Année dernière',
  'dynamic-cards-search-page.document-search-result.google-sheets-label': 'Sheets',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Générer une réponse',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Récents',
  'dynamic-cards-search-page.error_primary': 'Une erreur est survenue lors de la recherche',
  'dynamic-cards-search-page.error_secondary':
    "Ce n'est peut-être que temporaire. La meilleure chose à faire est de <btn>réessayer</btn>.",
  'dynamic-cards-search-page.externalPeopleLabel': 'Personnes externes #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Effacer le filtre',
  'dynamic-cards-search-page.filter.last.updated.anytime': "N'importe quand",
  'dynamic-cards-search-page.filter.last.updated.past30Days': '30 derniers jours',
  'dynamic-cards-search-page.filter.last.updated.past7Days': '7 derniers jours',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Année dernière',
  'dynamic-cards-search-page.filter.last.updated.today': "Aujourd'hui",
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Hier',
  'dynamic-cards-search-page.filter.type.answer': 'Réponses',
  'dynamic-cards-search-page.filter.type.attachment': 'Pièces jointes',
  'dynamic-cards-search-page.filter.type.blogpost': 'Billets de blog',
  'dynamic-cards-search-page.filter.type.branch': 'Branches',
  'dynamic-cards-search-page.filter.type.calendar': 'Calendriers',
  'dynamic-cards-search-page.filter.type.card': 'Carte',
  'dynamic-cards-search-page.filter.type.comment': 'Commentaires',
  'dynamic-cards-search-page.filter.type.commit': 'Commits',
  'dynamic-cards-search-page.filter.type.component': 'Composants',
  'dynamic-cards-search-page.filter.type.conversation': 'Conversations',
  'dynamic-cards-search-page.filter.type.database': 'Bases de données',
  'dynamic-cards-search-page.filter.type.design': 'Designs',
  'dynamic-cards-search-page.filter.type.documents': 'Documents',
  'dynamic-cards-search-page.filter.type.embed': 'Liens intelligents',
  'dynamic-cards-search-page.filter.type.folder': 'Dossiers',
  'dynamic-cards-search-page.filter.type.issue': 'Tickets',
  'dynamic-cards-search-page.filter.type.message': 'Messages',
  'dynamic-cards-search-page.filter.type.page': 'Pages',
  'dynamic-cards-search-page.filter.type.placeholder': 'Rechercher un type',
  'dynamic-cards-search-page.filter.type.presentation': 'Présentations',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull requests',
  'dynamic-cards-search-page.filter.type.question': 'Questions',
  'dynamic-cards-search-page.filter.type.repository': 'Dépôts',
  'dynamic-cards-search-page.filter.type.space': 'Espaces',
  'dynamic-cards-search-page.filter.type.space-calendar': "Calendriers d'espace",
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Feuilles de calcul',
  'dynamic-cards-search-page.filter.type.tag': 'Étiquettes',
  'dynamic-cards-search-page.filter.type.video': 'Vidéos',
  'dynamic-cards-search-page.filter.type.web-page': 'Pages web',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Tableaux blancs',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Effacer tout',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filtre',
  'dynamic-cards-search-page.filters.names.content': 'Contenu sous',
  'dynamic-cards-search-page.filters.names.contributor': 'Contributeur',
  'dynamic-cards-search-page.filters.names.labels': 'Étiquette',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Correspondance avec le titre',
  'dynamic-cards-search-page.filters.names.verified': 'Vérifié',
  'dynamic-cards-search-page.github-branch-result.label': 'Branche',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull request',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Recherchez du contenu',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Rechercher des projets',
  'dynamic-cards-search-page.landing_primary': 'Lancez-vous avec les filtres pour les cartes dynamiques',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Docs',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Slides',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': "Nous n'avons trouvé aucun résultat correspondant à votre recherche",
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Il semble que vous avez appliqué certains filtres. Essayez peut-être de les effacer.',
  'dynamic-cards-search-page.nouns.goal': 'Objectif',
  'dynamic-cards-search-page.nouns.goals': 'Objectifs',
  'dynamic-cards-search-page.nouns.tag': 'Tag',
  'dynamic-cards-search-page.nouns.tags': 'Tags',
  'dynamic-cards-search-page.number_of_results':
    'Affichage de {numberOfResults,number} résultats sur {totalCount,number}',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': "Échec de l'autorisation pour {product}.",
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Autorisation réussie pour {product}.',
  'dynamic-cards-search-page.oauth-message-connect': 'Connecter',
  'dynamic-cards-search-page.products.custom-website': 'Page web',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Trier par date de création (la plus récente)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Date de création (la plus récente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Date de mise à jour (la plus récente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected':
    'Trier par date de mise à jour (la plus récente)',
  'dynamic-cards-search-page.results-sort.sort-options.label': "Modifier l'ordre de tri de la liste",
  'dynamic-cards-search-page.rovo-onboarding-next': 'Suivant',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtrez par produit pour augmenter la pertinence des résultats de la recherche.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading':
    "Faites des recherches dans tous vos espaces de travail d'entreprise",
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'En fonction du produit défini dans votre filtre, ces options changent pour vous aider à obtenir des résultats spécifiques.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Trouvez exactement ce que vous recherchez',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Pièce jointe',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label':
    "Date d'ajout de la pièce jointe : {formattedDate}",
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Image',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Mise à jour : {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Canal privé',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Icône Supprimer la recherche récente',
  'dynamic-cards-search-page.search-result.repository-label': 'Dépôt',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Message de groupe avec des utilisateurs externes} =2 {{name1} et {name2}} =3 {{name1}, {name2} et {name3}} =4 {{name1}, {name2}, {name3} et {overflowContributorCount} autre} one {{name1}} other {{name1}, {name2}, {name3} et {overflowContributorCount} autres}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'canal-inconnu',
  'dynamic-cards-search-page.search_result_type_answer': 'Réponse',
  'dynamic-cards-search-page.search_result_type_comment': 'Commenter',
  'dynamic-cards-search-page.search_result_type_component': 'Composant',
  'dynamic-cards-search-page.search_result_type_document': 'Document',
  'dynamic-cards-search-page.search_result_type_embed': 'Lien intelligent',
  'dynamic-cards-search-page.search_result_type_folder': 'Dossier',
  'dynamic-cards-search-page.search_result_type_plan': 'Offre',
  'dynamic-cards-search-page.search_result_type_presentation': 'Présentation',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull request',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Document SharePoint',
  'dynamic-cards-search-page.search_result_type_space_calendar': "Calendrier d'espace",
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Feuille de calcul',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Non reconnu',
  'dynamic-cards-search-page.search_result_type_work_item': 'Ticket',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Votre administrateur a ajouté <strong>{product}</strong> !{br} Connectez votre compte pour voir les résultats manquants, y compris les documents auxquels vous seul avez accès.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} est maintenant disponible !</strong>{br} Connectez votre compte pour voir les résultats manquants, y compris les documents auxquels vous seul avez accès.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autoriser',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': "Échec de l'autorisation pour {product}.",
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Autorisation réussie pour {product}.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrer par toutes les apps',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrer par apps supplémentaires',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archivé',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'À risque',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Annulé',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Terminé',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Délais dépassés',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Dans les temps',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'En pause',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'En attente',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} chapitre dans cette vidéo} other {{chapterCount,number} chapitres dans cette vidéo}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'icône de vidéo',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniature de vidéo',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'est assigné(e)',
  'dynamic-cards-search-page.work-item-creator.created': 'a créé ce contenu',
  'dynamic-cards-search-page.work-item-status.for': 'pour',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Ticket',
  'initialsAvatar.label': 'Avatar avec les initiales',
  'personAvatar.label': 'Avatar de la personne',
  'search-page.results.private-result-label': 'Privé',
  'search-page.results.private-result-tooltip': 'Seulement visible par vous',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} membre} other {{memberCount,number} membres}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} membre} other {{count,number} membres}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Dernière activité : {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'canal-inconnu',
  'search-page.results.product-results.third-party.external-people-label': 'Personnes externes',
  'search-page.results.product-results.third-party.external-person-label': 'Personne externe',
  'search-page.results.product-results.third-party.last-active': 'Dernière activité : {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Message',
  'search-page.results.product-results.third-party.no-contributors-label': 'Personnes externes dans #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} dans une conversation privée',
  'search-page.results.product-results.third-party.thread-type-label': 'Fil de discussion',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} dans #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} et {remainingContributorsCount} autre} other {{title} et {remainingContributorsCount} autres}}',
  'search-page.results.restricted-result-label': 'Restreint',
  'search-page.results.restricted-result-tooltip': 'Seulement visible par des personnes spécifiques',
  'search-page.show-more-breadcrumbs-button-label': "Afficher plus de fils d'Ariane",
  'search-page.verified-icon-label': 'Vérifiée',
  'search-page.verified-icon-tooltip-message': 'Cette page a été vérifiée par un propriétaire ou un administrateur.',
  'search-result.result.count':
    '{count, plural, one {Affichage de {count} résultat} other {Affichage de {count} résultats}}',
  'search-result.user-mention.external-person': 'Personne externe',
};
